import _objectSpread from "/var/lib/jenkins/workspace/wyt-admin/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.sort.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "pc-menu-manage"
};

const _hoisted_2 = /*#__PURE__*/_createTextVNode("新增一级");

const _hoisted_3 = /*#__PURE__*/_createTextVNode("新增二级");

const _hoisted_4 = /*#__PURE__*/_createTextVNode("刷新");

const _hoisted_5 = /*#__PURE__*/_createTextVNode("编辑");

const _hoisted_6 = /*#__PURE__*/_createTextVNode("删除");

const _hoisted_7 = /*#__PURE__*/_createTextVNode("取消");

const _hoisted_8 = /*#__PURE__*/_createTextVNode("保存");

import { computed, onMounted, ref, watch } from 'vue';
import { ElMessage, ElMessageBox } from 'element-plus';
import { deletePcMenu, getPcMenuTree, savePcMenu } from '@/request';
export default {
  name: 'PcMenuManage',

  setup(__props) {
    const resourceType = ref('0');
    const tableData = ref([]);
    const currentRow = ref(null);
    const showModal = ref(false);
    const formRef = ref();
    const isTop = ref(true);
    const form = ref(emptyForm());
    const topMenus = computed(() => tableData.value || []);

    function emptyForm() {
      return {
        resourceId: null,
        resourceName: '',
        routeKey: '',
        parentId: null,
        sort: '',
        icon: '',
        url: '',
        path: '',
        note: ''
      };
    }

    onMounted(() => loadTree());
    watch(resourceType, () => loadTree());

    function loadTree() {
      getPcMenuTree({
        resourceType: Number(resourceType.value)
      }).then(res => {
        tableData.value = res.data || [];
        currentRow.value = null;
      });
    }

    function onCurrentChange(row) {
      currentRow.value = row;
    }

    function openAdd(parentId) {
      isTop.value = parentId == null;
      form.value = _objectSpread(_objectSpread({}, emptyForm()), {}, {
        parentId,
        sort: isTop.value ? '10' : '10'
      });
      showModal.value = true;
    }

    function openAddChild() {
      if (!currentRow.value || currentRow.value.parentId != null) {
        ElMessage.warning('请先选中一级菜单');
        return;
      }

      openAdd(currentRow.value.resourceId);
    }

    function openEdit(row) {
      isTop.value = row.parentId == null;
      form.value = {
        resourceId: row.resourceId,
        resourceName: row.resourceName || '',
        routeKey: row.routeKey || '',
        parentId: row.parentId,
        sort: row.sort || '',
        icon: row.icon || '',
        url: row.url || '',
        path: row.path || '',
        note: row.note || ''
      };
      showModal.value = true;
    }

    function submit() {
      formRef.value.validate(valid => {
        if (!valid) return;

        const payload = _objectSpread(_objectSpread({}, form.value), {}, {
          resourceType: Number(resourceType.value),
          __repeat: true,
          __warn: true
        });

        if (isTop.value) {
          payload.parentId = null;
          payload.routeKey = null;
        }

        savePcMenu(payload).then(() => {
          ElMessage.success('保存成功');
          showModal.value = false;
          loadTree();
        });
      });
    }

    function handleDelete(row) {
      if (row.children && row.children.length) {
        ElMessage.warning('请先删除子菜单');
        return;
      }

      ElMessageBox.confirm('删除后角色授权关联不会自动清理，但不影响菜单展示。确认删除？', '删除菜单').then(() => {
        deletePcMenu({}, {
          params: {
            resourceId: row.resourceId,
            __repeat: true,
            __warn: true
          }
        }).then(() => {
          ElMessage.success('删除成功');
          loadTree();
        });
      });
    }

    return (_ctx, _cache) => {
      const _component_el_tab_pane = _resolveComponent("el-tab-pane");

      const _component_el_tabs = _resolveComponent("el-tabs");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_row = _resolveComponent("el-row");

      const _component_el_table_column = _resolveComponent("el-table-column");

      const _component_el_table = _resolveComponent("el-table");

      const _component_el_input = _resolveComponent("el-input");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_option = _resolveComponent("el-option");

      const _component_el_select = _resolveComponent("el-select");

      const _component_el_form = _resolveComponent("el-form");

      const _component_el_dialog = _resolveComponent("el-dialog");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_tabs, {
        modelValue: resourceType.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => resourceType.value = $event)
      }, {
        default: _withCtx(() => [_createVNode(_component_el_tab_pane, {
          label: "超管菜单",
          name: "0"
        }), _createVNode(_component_el_tab_pane, {
          label: "分管菜单",
          name: "3"
        }), _createVNode(_component_el_tab_pane, {
          label: "业务员菜单",
          name: "2"
        })]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_el_row, {
        style: {
          "margin-bottom": "12px"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_el_button, {
          type: "primary",
          icon: "Plus",
          onClick: _cache[1] || (_cache[1] = $event => openAdd(null))
        }, {
          default: _withCtx(() => [_hoisted_2]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          icon: "Plus",
          onClick: openAddChild
        }, {
          default: _withCtx(() => [_hoisted_3]),
          _: 1
        }), _createVNode(_component_el_button, {
          icon: "Refresh",
          onClick: loadTree
        }, {
          default: _withCtx(() => [_hoisted_4]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_table, {
        data: tableData.value,
        "row-key": "resourceId",
        border: "",
        "default-expand-all": "",
        "tree-props": {
          children: 'children'
        },
        "highlight-current-row": "",
        onCurrentChange: onCurrentChange
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          prop: "resourceName",
          label: "菜单名称",
          "min-width": "180"
        }), _createVNode(_component_el_table_column, {
          prop: "routeKey",
          label: "route_key",
          "min-width": "140"
        }), _createVNode(_component_el_table_column, {
          prop: "sort",
          label: "排序",
          width: "80"
        }), _createVNode(_component_el_table_column, {
          prop: "icon",
          label: "图标",
          width: "100"
        }), _createVNode(_component_el_table_column, {
          prop: "url",
          label: "url",
          "min-width": "180",
          "show-overflow-tooltip": ""
        }), _createVNode(_component_el_table_column, {
          label: "操作",
          width: "160",
          fixed: "right"
        }, {
          default: _withCtx(({
            row
          }) => [_createVNode(_component_el_button, {
            type: "primary",
            link: "",
            onClick: $event => openEdit(row)
          }, {
            default: _withCtx(() => [_hoisted_5]),
            _: 2
          }, 1032, ["onClick"]), _createVNode(_component_el_button, {
            type: "danger",
            link: "",
            onClick: $event => handleDelete(row)
          }, {
            default: _withCtx(() => [_hoisted_6]),
            _: 2
          }, 1032, ["onClick"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["data"]), _createVNode(_component_el_dialog, {
        modelValue: showModal.value,
        "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => showModal.value = $event),
        title: form.value.resourceId ? '编辑菜单' : '新增菜单',
        width: "560px"
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: _cache[10] || (_cache[10] = $event => showModal.value = false)
        }, {
          default: _withCtx(() => [_hoisted_7]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: submit
        }, {
          default: _withCtx(() => [_hoisted_8]),
          _: 1
        })]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          ref_key: "formRef",
          ref: formRef,
          model: form.value,
          "label-width": "100px"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "菜单名称",
            prop: "resourceName",
            rules: {
              required: true,
              message: '请输入菜单名称'
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.value.resourceName,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form.value.resourceName = $event),
              maxlength: "50"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), !isTop.value ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 0,
            label: "父级菜单",
            prop: "parentId",
            rules: {
              required: true,
              message: '请选择父级'
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: form.value.parentId,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => form.value.parentId = $event),
              style: {
                "width": "100%"
              },
              filterable: ""
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(topMenus), item => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: item.resourceId,
                  label: item.resourceName,
                  value: item.resourceId
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          })) : _createCommentVNode("", true), !isTop.value ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 1,
            label: "route_key",
            prop: "routeKey",
            rules: {
              required: true,
              message: '请填写路由键'
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.value.routeKey,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => form.value.routeKey = $event),
              maxlength: "64",
              placeholder: "需与前端 meta.id 一致"
            }, null, 8, ["modelValue"])]),
            _: 1
          })) : _createCommentVNode("", true), _createVNode(_component_el_form_item, {
            label: "排序",
            prop: "sort",
            rules: {
              required: true,
              message: '请输入排序'
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.value.sort,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => form.value.sort = $event)
            }, null, 8, ["modelValue"])]),
            _: 1
          }), isTop.value ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 2,
            label: "图标"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.value.icon,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => form.value.icon = $event),
              placeholder: "如 User、Goods"
            }, null, 8, ["modelValue"])]),
            _: 1
          })) : _createCommentVNode("", true), !isTop.value ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 3,
            label: "url"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.value.url,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => form.value.url = $event)
            }, null, 8, ["modelValue"])]),
            _: 1
          })) : _createCommentVNode("", true), !isTop.value ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 4,
            label: "path"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.value.path,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => form.value.path = $event)
            }, null, 8, ["modelValue"])]),
            _: 1
          })) : _createCommentVNode("", true), _createVNode(_component_el_form_item, {
            label: "备注"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.value.note,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => form.value.note = $event),
              type: "textarea",
              rows: 2
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"])]),
        _: 1
      }, 8, ["modelValue", "title"])]);
    };
  }

};